// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__JRKRe","calendarButtons":"ClockData_calendarButtons__3cA4B"};